import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=50ee8968&scoped=true&"
import script from "./Step3.vue?vue&type=script&lang=ts&"
export * from "./Step3.vue?vue&type=script&lang=ts&"
import style0 from "./Step3.vue?vue&type=style&index=0&id=50ee8968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ee8968",
  null
  
)

export default component.exports